// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const LogOutIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="logout" fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}><path id="Shape" fill="currentColor" fillRule="nonzero" d="M2 18q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 16V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h7v2H2v14h7v2zm11-4-1.375-1.45 2.55-2.55H6V8h8.175l-2.55-2.55L13 4l5 5z" /></g></svg>
))
